// /src/components/PhotoCard.tsx
import React from "react";
import { Photo } from "../types";
import { Link } from "react-router-dom";
import styles from "../styles/ArtworkCard.module.css"; // reuse styles

interface PhotoCardProps {
  photo: Photo;
}

export const PhotoCard: React.FC<PhotoCardProps> = ({ photo }) => {
  return (
    <Link to={`/photogallery/${photo.id}`} className={styles.cardLink}>
      <div className={styles.card}>
        <div className={styles.imageContainer}>
          <img src={photo.imageUrl} alt={photo.title} className={styles.image} />
        </div>
        <div className={styles.overlay}>
          <h3 className={styles.title}>{photo.title}</h3>
          {(photo.tags?.length > 0 || photo.year) && (
            <p className={styles.meta}>
              {photo.year ? photo.year : ""}{" "}
              {photo.tags?.length ? "• " + photo.tags.join(" / ") : ""}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};
